import { FunctionComponent, useState } from 'react';
import styles from './layout.module.css';
import { LayoutProps } from './layout.types';
import PageHeader from '../pageHeader/pageHeader';
import { validateAndDecodeAuthToken } from '../../utils/helper';
import { AuthTokenResponse } from '../../service/service.type';
import { useLocation } from 'react-router-dom';
import Sidebar from '../sidebar/sidebarNew';
import { route } from '../../service/router';
import { useUserDetailContext } from '../../service/context/userDetailContext';

const Layout: FunctionComponent<LayoutProps> = (props: LayoutProps) => {
  const { userDetail } = useUserDetailContext();

  const validAuthToken: AuthTokenResponse | null = validateAndDecodeAuthToken();
  const initialNames: string = `${userDetail?.firstName?.[0] ?? ''}${
    userDetail?.lastName?.[0] ?? ''
  }`;
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

  const getModuleName = (): string => {
    if (location.pathname === route.dashboard) {
      return 'menuItems.dashboard';
    } else if (location.pathname === route.userManagement) {
      return 'menuItems.userManagement';
    } else if (location.pathname === route.sweeps) {
      return 'menuItems.sweeps';
    } else if (location.pathname === route.harmReports) {
      return 'menuItems.harmReports';
    } else if (location.pathname === route.interventionReports) {
      return 'menuItems.interventionReports';
    } else {
      return '';
    }
  };

  return (
    <main className={styles.main}>
      <Sidebar
        currentPath={location.pathname}
        isSidebarOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        userType={validAuthToken?.type ?? ''}
      />
      <aside
        className={`${styles.content} ${
          sidebarOpen ? styles.contentOpen : styles.contentClosed
        }`}
      >
        <PageHeader
          title={getModuleName()}
          username={initialNames}
          isSidebarOpen={sidebarOpen}
          onHamburgerClick={() => setSidebarOpen(!sidebarOpen)}
        />
        <div className={styles.container}>{props.children}</div>
      </aside>
    </main>
  );
};

export default Layout;
